<template>
  <transition name="modal">
    <div class="modal__mask modalpep" v-if="showModalCreate">
      <div class="modal__wrapper">
        <div class="modal__container reset">
          <div class="content__modal">
            <div class="inner__modal_pep">
              <img
                style="width: 40px; height: 47px"
                src="@/assets/question.png"
              />
              <h2>Tipos de investidores</h2>

              <br />
              <br />

              <span>
                Investidor Qualificado:
                <br />
                <strong
                  >Declaro que possuo mais de R$ 1 milhão investidos em
                  aplicações financeiras ou possuo certificações específicas do
                  mercado financeiro.</strong
                >
              </span>

              <br />
              <br />

              <span>
                Investidor Profissional:
                <br />
                <strong
                  >Declaro que possuo mais de R$ 10 milhões investidos em
                  aplicações financeiras ou sou participante do mercado
                  financeiro com atuação profissional.</strong
                >
              </span>

              <br />
              <br />

              <span>
                Investidor em Geral:
                <br />
                <strong
                  >Declaro que não me enquadro nas classificações acima.</strong
                >
              </span>

              <div class="buttonsAcoes" style="padding-bottom: 30px">
                <button
                  class="btnDefault"
                  style="width: 290px"
                  @click="closeModal"
                >
                  Entendi
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      showModalCreate: "GET_MODAL_INVESTIDOR_INFORMATIVO",
      user: "auth/user",
    }),
  },
  methods: {
    closeModal() {
      this.$store.commit("SET_MODAL_INVESTIDOR_INFORMATIVO", false);
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap");
</style>
